export default "__VITE_ASSET__x7k6KLzD__"